import React from 'react';

export const HeroSection: React.FC = () => {
  return (
    <section className="relative min-h-screen overflow-hidden" style={{
      background: 'radial-gradient(ellipse at bottom left, #1a2b3d 0%, #0f1d2b 50%, #0f1d2b 100%)'
    }}>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center min-h-[80vh]">
          {/* Left Content */}
          <div className="text-left space-y-6 lg:space-y-8">
            {/* Logo and Brand Section */}
            <div className="flex items-center space-x-4 lg:space-x-6 mb-6 lg:mb-8">
              <div className="relative">
                <div 
                  className="w-16 h-16 lg:w-24 lg:h-24 rounded-full shadow-2xl flex items-center justify-center relative overflow-hidden"
                  style={{ 
                    backgroundColor: 'transparent'
                  }}
                >
                  <img 
                    src="https://static.readdy.ai/image/62550bc47b27f12b31ed19b5600db8cd/ec269de17ab2b3f3aaea809d27439652.jpeg"
                    alt="MãoForte Logo"
                    className="w-12 h-12 lg:w-16 lg:h-16 object-cover rounded-full"
                  />
                </div>
              </div>
              
              <div>
                <h1 className="font-poppins font-bold text-3xl lg:text-5xl leading-tight" style={{ color: '#ffffff' }}>
                  Mão<span style={{ color: '#ff6a00' }}>Forte</span>
                </h1>
                <p className="font-poppins text-base lg:text-lg font-medium mt-2 lg:mt-2" style={{ color: '#ff6a00' }}>
                  Construção & Reformas
                </p>
              </div>
            </div>

            {/* Main Message */}
            <h2 className="font-poppins font-bold text-xl lg:text-2xl leading-tight" style={{ color: '#ffffff' }}>
              Conectando pessoas, construindo oportunidades.
            </h2>

            {/* Subtitle */}
            <p className="font-poppins text-base lg:text-lg leading-relaxed max-w-2xl" style={{
              color: '#cfd6e3'
            }}>
              A MãoForte conecta clientes que precisam de reformas com profissionais qualificados e engenheiros experientes.
            </p>

            {/* Test Message Balloon - Moved above features */}
            <div className="relative mb-6 lg:mb-8 mt-6 lg:mt-8">
              <div className="bg-orange-500/20 border border-orange-500/40 rounded-xl lg:rounded-2xl p-4 lg:p-6 backdrop-blur-sm">
                <div className="flex items-start space-x-3 lg:space-x-4">
                  <div className="w-6 h-6 lg:w-8 lg:h-8 bg-orange-500 rounded-full flex items-center justify-center flex-shrink-0 mt-1 lg:mt-1">
                    <i className="ri-information-line text-white text-sm lg:text-sm"></i>
                  </div>
                  <div className="space-y-2 lg:space-y-2">
                    <p className="text-orange-100 font-bold text-sm lg:text-base">
                      <strong>Plataforma em Desenvolvimento </strong>
                    </p>
                    <p className="text-orange-50 text-sm lg:text-sm leading-relaxed">
                      Estamos construindo a maior plataforma de construção do Brasil. Cadastre-se agora e seja um dos primeiros a fazer parte dessa revolução!
                    </p>
                    <p className="text-orange-100 font-medium text-sm lg:text-sm">
                      Seja um dos primeiros a experimentar nossa tecnologia
                    </p>
                  </div>
                </div>
              </div>
              {/* Balloon tail */}
              <div 
                className="absolute -bottom-1 lg:-bottom-2 left-6 lg:left-8 w-3 h-3 lg:w-4 lg:h-4 rotate-45 border-r border-b border-orange-500/40"
                style={{ backgroundColor: 'rgba(255, 106, 0, 0.2)' }}
              ></div>
            </div>

            {/* Features List - Reorganized in 2 rows */}
            <div className="space-y-4 lg:space-y-6 pt-4 lg:pt-4">
              {/* First Row */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 lg:gap-6">
                <div className="flex items-center space-x-3 lg:space-x-4">
                  <div className="w-6 h-6 lg:w-8 lg:h-8 bg-orange-500 rounded-full flex items-center justify-center">
                    <i className="ri-shield-check-fill text-sm lg:text-lg text-white"></i>
                  </div>
                  <span className="font-poppins text-sm lg:text-base font-medium" style={{ color: '#cfd6e3' }}>
                    Profissionais Verificados
                  </span>
                </div>
                <div className="flex items-center space-x-3 lg:space-x-4">
                  <div className="w-6 h-6 lg:w-8 lg:h-8 bg-orange-500 rounded-full flex items-center justify-center">
                    <i className="ri-flashlight-fill text-sm lg:text-lg text-white"></i>
                  </div>
                  <span className="font-poppins text-sm lg:text-base font-medium" style={{ color: '#cfd6e3' }}>
                    Processo Rápido
                  </span>
                </div>
              </div>
              
              {/* Second Row */}
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 lg:gap-6">
                <div className="flex items-center space-x-3 lg:space-x-4">
                  <div className="w-6 h-6 lg:w-8 lg:h-8 bg-orange-500 rounded-full flex items-center justify-center">
                    <i className="ri-customer-service-2-fill text-sm lg:text-lg text-white"></i>
                  </div>
                  <span className="font-poppins text-sm lg:text-base font-medium" style={{ color: '#cfd6e3' }}>
                    Suporte Total
                  </span>
                </div>
                <div className="flex items-center space-x-3 lg:space-x-4">
                  <div className="w-6 h-6 lg:w-8 lg:h-8 bg-orange-500 rounded-full flex items-center justify-center">
                    <i className="ri-money-dollar-circle-fill text-sm lg:text-lg text-white"></i>
                  </div>
                  <span className="font-poppins text-sm lg:text-base font-medium" style={{ color: '#cfd6e3' }}>
                    Preços Justos
                  </span>
                </div>
              </div>
            </div>

            {/* CTA Buttons */}
            <div className="flex flex-col gap-3 lg:gap-4 pt-6 lg:pt-8">
              <a 
                href="https://forms.gle/iSEceoYsLHpAJhxF9"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center font-poppins font-medium rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer text-sm lg:text-base"
                style={{
                  backgroundColor: '#ff6a00',
                  color: '#ffffff',
                  padding: '12px 16px',
                  borderRadius: '8px',
                  boxShadow: '0 4px 10px rgba(255, 106, 0, 0.3)'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#e55a00';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = '#ff6a00';
                }}
              >
                <i className="ri-briefcase-line mr-2 lg:mr-3 text-sm lg:text-base"></i>
                Quero Participar como Profissional
              </a>
              <a 
                href="https://forms.gle/vyDyvwdnn3pdBBRW8"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center font-poppins font-medium rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer text-sm lg:text-base"
                style={{
                  border: '2px solid #ff6a00',
                  color: '#ff6a00',
                  backgroundColor: 'transparent',
                  padding: '12px 16px',
                  borderRadius: '8px'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = '#ff6a00';
                  e.currentTarget.style.color = '#ffffff';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = 'transparent';
                  e.currentTarget.style.color = '#ff6a00';
                }}
              >
                <i className="ri-home-repair-line mr-2 lg:mr-3 text-sm lg:text-base"></i>
                Quero Reformar meu Imóvel
              </a>
            </div>
          </div>

          {/* Right Content - Logo with Gradient Circles - Hidden on mobile */}
          <div className="hidden lg:flex justify-center lg:justify-end">
            <div className="relative">
              {/* Gradient Concentric Circles - Only 2 circles without borders */}
              <div className="absolute inset-0 flex items-center justify-center">
                <div 
                  className="w-80 h-80 rounded-full"
                  style={{ 
                    backgroundColor: 'rgba(255, 106, 0, 0.15)'
                  }}
                ></div>
              </div>
              <div className="absolute inset-0 flex items-center justify-center">
                <div 
                  className="w-56 h-56 rounded-full"
                  style={{ 
                    backgroundColor: 'rgba(255, 106, 0, 0.4)'
                  }}
                ></div>
              </div>

              {/* Central Logo Circle */}
              <div className="relative w-96 h-96 flex items-center justify-center">
                <div 
                  className="w-40 h-40 rounded-full shadow-2xl flex items-center justify-center relative overflow-hidden"
                  style={{ 
                    backgroundColor: '#ff6a00'
                  }}
                >
                  {/* Logo Image */}
                  <div className="relative z-10 flex items-center justify-center w-full h-full">
                    <img 
                      src="https://static.readdy.ai/image/62550bc47b27f12b31ed19b5600db8cd/ec269de17ab2b3f3aaea809d27439652.jpeg"
                      alt="MãoForte Logo"
                      className="w-28 h-28 object-cover rounded-full"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};